import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import Mousetrap from 'mousetrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

import { COLOR_THEME, LOGO_URL } from '../utils/themer';
import XOSLogo from '../images/logo.png';
import { toggleSidebar } from '../state/sidebar';
import GroupsPicker from './GroupsPicker';
import PurposePicker from './PurposePicker';
import PagePicker from './PagePicker';
import GeneralSettingsPicker from './GeneralSettingsPicker';
import isFootball from '../state/selectors/isFootball';
import { getAllFilters } from '../state/filters';

const NavigationBarContainer = styled.div`
  height: 60px;
  width: 100%;
  background: ${COLOR_THEME.primary};
  display: flex;
`;

const LogoContainer = styled.div`
  position: relative;
  width: 170px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  left: 20px;

  img {
    max-width: 160px;
    max-height: 45px;
    padding-left: 90px;
  }

  span {
    color: white;
    padding-left: 20px;
    font-size: 1.5rem;
  }
`;

const SidebarToggle = styled.div`
  position: absolute;
  left: 0;
  color: white;
  cursor: pointer;
`;

const FilterProfileContainer = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 25px;
`;

export class NavigationBar extends PureComponent {
  constructor(props) {
    super(props);
    this.keyboardShortcut = ['command+b', 'ctrl+b'];
  }

  componentDidMount() {
    const { groupId, toggleSidebar, getAllFilters } = this.props;
    Mousetrap.bind(this.keyboardShortcut, toggleSidebar);

    if (groupId) getAllFilters(groupId);
  }

  componentDidUpdate(prevProps) {
    const { groupId, getAllFilters } = this.props;
    if (prevProps.groupId !== groupId) {
      getAllFilters(groupId);
    }
  }

  componentWillUnmount() {
    Mousetrap.unbind(this.keyboardShortcut);
  }

  render() {
    const {
      t, isSidebarCollapsed, isFootball, toggleDisabled, toggleSidebar,
    } = this.props;

    return (
      <NavigationBarContainer>
        <LogoContainer>
          {isFootball && !toggleDisabled && (
            <SidebarToggle id="NavigationBar.ToggleSidebar" onClick={toggleSidebar}>
              <FontAwesomeIcon icon={isSidebarCollapsed ? faBars : faTimes} />
            </SidebarToggle>
          )}
          <img id="NavigationBar.Logo" src={LOGO_URL || XOSLogo} alt={t('NavigationBar.Logo')} />
          <span id="NavigationBar.Title">Dashboard</span>
        </LogoContainer>
        <FilterProfileContainer>
          <GroupsPicker />
          <PurposePicker />
          <PagePicker />
          <GeneralSettingsPicker />
        </FilterProfileContainer>
      </NavigationBarContainer>
    );
  }
}

NavigationBar.propTypes = {
  getAllFilters: PropTypes.func.isRequired,
  groupId: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  isSidebarCollapsed: PropTypes.bool.isRequired, // supplied from Redux
  isFootball: PropTypes.bool.isRequired, // supplied from Redux
  toggleSidebar: PropTypes.func.isRequired, // supplied from Redux
  toggleDisabled: PropTypes.bool.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

const mapStateToProps = state => ({
  isSidebarCollapsed: state.sidebar.isCollapsed,
  groupId: state.navigationSelection.group.groupId,
  isFootball: isFootball(state),
  toggleDisabled: state.sidebar.toggleDisabled,
});

const mapDispatchToProps = {
  toggleSidebar,
  getAllFilters,
};

const TranslatedComponent = withTranslation()(NavigationBar);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
